import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DropdownComponent} from './components/dropdown/dropdown.component';
import {FormattedCodeComponent} from './documentation/formatted-code.component';
import {OneTimeDirective} from './directives/bind-once';
import {ClearSpacesInAutocompleteDirective} from './directives/clear-spaces-in-autocomplete.directive';
import {ClearSpacesDirective} from './directives/clear-spaces.directive';
import {OrderByPipe} from './pipes/order-by.pipe';
import {TtdDataRateComponent} from './ttd/ttd-data-rate/ttd-data-rate.component';
import {MaterialModule} from './material.module';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule

  ],
  declarations: [
    OrderByPipe,
    FormattedCodeComponent,
    DropdownComponent,
    ClearSpacesInAutocompleteDirective,
    ClearSpacesDirective,
    OneTimeDirective,
    TtdDataRateComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    OrderByPipe,
    FormattedCodeComponent,
    DropdownComponent,
    ClearSpacesInAutocompleteDirective,
    ClearSpacesDirective,
    OneTimeDirective,
    TtdDataRateComponent
  ]
})
export class SharedModule {
}
